import React from 'react';
import { enums, Icon } from 'console-kit';
import PropTypes from 'prop-types';

/**
 * LightboxIcon component
 */
const LightboxIcon = ({ svgIcon, size = enums.sizes.X8 }) => (
  <Icon src={`${App.globalContext.assetURL}c/img/experience-workspace/${svgIcon}-launch-trigger.svg`} size={size} />
);

LightboxIcon.propTypes = {
  svgIcon: PropTypes.string.isRequired,
  size:    PropTypes.string,
};

export default LightboxIcon;
